import React, { useEffect, useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import styles from "./Switch.module.scss";

const Switch = ({ action, switchStyle, defaultActive, disabled }) => {
  const [active, isActive] = useState(defaultActive);

  useEffect(() => {
    isActive(defaultActive);
  }, [defaultActive]);

  const handleChange = () => {
    if (disabled) return;
    isActive(!active);
    action();
  };

  const classes = classNames(styles.switch, {
    [styles.smallSwitch]: switchStyle === "small",
    [styles.bigSwitch]: switchStyle === "big",
    [styles.disabled]: disabled,
  });

  return (
    <label className={classes}>
      <input
        type="checkbox"
        checked={active}
        onChange={handleChange}
        disabled={disabled}
      />
      <span className={styles.slider} />
    </label>
  );
};

Switch.propTypes = {
  action: PropTypes.func,
  switchStyle: PropTypes.string,
  defaultActive: PropTypes.bool,
  disabled: PropTypes.bool,
};

Switch.defaultProps = {
  action: () => {},
  switchStyle: "big",
  defaultActive: false,
};

export default Switch;
